module.exports = {
	"header.logo.title": "GROHE SmartControl douche-keuzehulp",
	"footer.privacy.text": "Privacy",
	"footer.privacy.url": "https://www.grohe.nl/nl_nl/bedrijf/privacy.html",
	"footer.disclaimer.text": "Disclaimer",
	"footer.disclaimer.url": "https://www.grohe.nl/nl_nl/privacybeleid.html",
	"footer.copyright": "© 2017 Grohe Nederland B.V.",
	"homepage.headline": "GROHE SmartControl douche-keuzehulp",
	"homepage.introtext": "Op zoek naar jouw ideale douche? Beantwoord een paar simpele vragen en vind de perfecte keuze voor jou binnen enkele seconden!",
	"homepage.buttonStart": "Start",
	"homepage.buttonStartTracking": "showersystem-configurator/start",
	"configurator.button.seeResults": "Bekijk resultaten",
	"question1.question": "Voor welke ruimte in je badkamer heb je een douche nodig?",
	"question1.option1.text": "Doucheruimte",
	"question1.option2.text": "Voor mijn bad, inclusief een baduitloop",
	"question2.question": "Welke type installatie heeft jouw voorkeur? Inbouw, opbouw of een combinatie daarvan? ",
	"question2.option1.text": "Opbouw: eenvoudige oplossing voor renovatie van je badkamer",
	"question2.option2.text": "Combinatie: opbouw installatie van thermostaatkraan met tray, maar met inbouwdouche",
	"question2.option3.text": "Inbouw: minimalistische look met alle techniek achter de muur verwerkt",
	"question3.question": "Hoe wil je je douche bedienen?",
	"question3.option1.text": "Met een SmartControl thermostaatkraan",
	"question3.option2.text": "Met een reguliere thermostaatkraan",
	"question3.option3.text": "Met een mengkraan",
	"question3.option4.text": "Met een omstelling (ik maak gebruik van mijn huidige douchekraan)",
	"question4.question": "Wat wil je bedienen in de douche?",
	"question4.option1.text": "Alleen een handdouche",
	"question4.option2.text": "Een grote hoofddouche (150-250 mm) en een handdouche",
	"question4.option3.text": "Een extra grote hoofddouche (250-400 mm) en een handdouche",
	"question4.option4.text": "Een grote hoofddouche (150-250 mm), een handdouche en een baduitloop",
	"question4.option5.text": "Een extra grote hoofddouche (250-400mm), een handdouche en een baduitloop",
	"question5.question": "Welke vorm heeft jouw voorkeur?",
	"question5.option1.text": "Vierkant",
	"question5.option2.text": "Rond",
	"question6.question": "Wat wil je bedienen met je nieuwe SmartControl?",
	"question6.option1.text": "Een hoofddouche met 2 straalsoorten en een handdouche",
	"question6.option2.text": "Een hoofddouche met twee straalsoorten en een handdouche",
	"question6.option3.text": "Een hoofddouche, handdouche en baduitloop",
	"question6.option4.text": "Een hoofddouche, twee zijdouches en een handdouche",
	"question6.option5.text": "Een hoofddouche en handdouche",
	"question6.option6.text": "Een handdouche en baduitloop",
	"question6.option7.text": "Alleen een handdouche",
	"question6.option8.text": "Alleen een baduitloop",
	"question7.question": "Kies de gewenste kleur",
	"question7.option1.text": "Chroom",
	"question7.option2.text": "Wit/chroom",
	"question7.option3.text": "Wit/chroom",
	"question8.question": "Wil je een thermostaatkraan met geïntegreerde handdouchehouder?",
	"question8.option1.text": "Ja, met geïntegreerde handdouchehouder",
	"question8.option2.text": "Nee ik koop separaat een handdouchehouder",
	"question9.question": "Hoe wil je je handdouche bevestigen?",
	"question9.option1.text": "Met een glijstang met verstelbare douchehouder",
	"question9.option2.text": "Met een minimalistische wandhouder",
	"question10.question": "Wil je een wandgemonteerde hoofddouche of een plafonddouche?",
	"question10.option1.text": "Wandgemonteerde hoofddouche",
	"question10.option2.text": "Plafonddouche",
	"results.title": "{productGroupsCount, plural, \none {Jouw resultaat} \nother {Jouw resultaten}\n}",
	"results.bundle.title": "Voor een correcte installatie heb je ook nodig:",
	"results.newConfiguration.buttonText": "Begin opnieuw",
	"results.product.button.productInformation": "Productinformatie",
	"results.product.button.dealerLocator": "Koop offline",
	"results.product.button.buyNow": "Koop online",
	"results.product.information": "Productinformatie",
	"results.product.dealer": "Zoek verkooppunt",
	"results.proposal.title": "Advies {number}",
	"results.proposal.title.single": "Advies",
	"results.newConfiguration.title": "Wil je opnieuw beginnen?",
	"results.product.number": "Artikelnummer: #{number}",
	"results.product.button.downloadPDF": "Download advies (PDF)",
	"404.title": "404 Pagina niet gevonden",
	"404.link.goBack": "Terug naar de homepage",
	"hatchModal.title": "Koop online",
	"hatchModal.btnText": "Nu kopen",
	"hatchModal.stockInfo": "{stockQuantity, plural, \nzero {Niet op voorraat} \nother {Op voorraad}\n}",
	"hatchModal.buyNow": "Nu kopen",
	"app.components.HomePage.header": "GROHE SmartControl douche-keuzehulp"
};


//////////////////
// WEBPACK FOOTER
// ./src/translations/shower.nl_nl.json
// module id = 755
// module chunks = 0